import React from "react";
import ProjectCard from "./ProjectCard";

const Project = () => {

  return (
    <div id="projects" className="jumbotron jumbotron-fluid bg-white m-0">
        <div id="stars"></div>
        <div className="container-fluid p-5">
          <h1 className="display-2 mb-5 text-center">Projects</h1>
          <div className="row">
              <ProjectCard/>
          </div>
        </div>
    </div>
  );
};

export default Project;